import { render, staticRenderFns } from "./PesquisaDocumentosView.vue?vue&type=template&id=4b2b9be5&scoped=true"
import script from "./PesquisaDocumentosView.vue?vue&type=script&lang=js"
export * from "./PesquisaDocumentosView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b9be5",
  null
  
)

export default component.exports